export default __webpack_public_path__ + "static/media/partner-ship-image.607b030f.webp";